import { getUserOrgId, linkPendingInvitesForUser } from "./orgHelpers"
import { acceptInvitation } from "./invitationHelpers"

// Determines where to send a user right after login, based on their account type.
// Also checks for and links any pending team invites matching this email, and
// accepts a pending learner invitation if ?invite= is present in the URL —
// same "check on every post-auth pass" pattern as team invites, just keyed by
// a specific invitation ID from the link instead of an email match.
export const getPostLoginPath = async (uid, email) => {
  await linkPendingInvitesForUser(uid, email).catch(() => {})

  const invitationId = new URLSearchParams(window.location.search).get("invite")
  if (invitationId) {
    await acceptInvitation(invitationId, uid).catch(() => {})
  }

  const { orgId } = await getUserOrgId(uid)
  return orgId ? "/organization-dashboard" : "/user-dashboard"
}